import useMutation from 'src/hook/useMutation'
import { PostsService } from 'src/services/posts'
import { BlockCommentsMutationProps } from './useBlockCommentsMutation.types'

const useBlockCommentsMutation = () => {
  const blockCommentsMutation = useMutation(
    ({ postId, isCommentsEnabled }: BlockCommentsMutationProps) =>
      PostsService.blockCommentsPost({ postId, isCommentsEnabled })
  )

  return {
    blockCommentsMutation
  }
}

export default useBlockCommentsMutation
